/*
 * Fetch the inventory levels for a product from the inventory API
 *
 * @param productSku {string} productSku: the SKU of the product to fetch
 *
 * @return {promise}: the promise of the fetch with all the response data included
 */

export const getIfsInventoryLevels = async (productSku) => {
  const mainUrl = 'https://x66ix5nef4.execute-api.us-east-1.amazonaws.com/default/ifs_product_inventory';
  const urlWithParams = `${mainUrl}?skus=${productSku}`;

  const ifsData = await fetch(urlWithParams)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => console.error(err));
  return ifsData;
};
